import { createReducer, on } from '@ngrx/store';
import {
  deleteClientSuccess,
  readClient,
  readClientFailure,
  readClients,
  readClientsFailure,
  readClientsSuccess,
  readClientSuccess,
  restoreClientSuccess,
  updateClientSuccess,
} from './client.actions';
import { ClientDto } from '@shared/dto';
import { PaginatedListQuery } from '@shared/interfaces/paginated-list-query.interface';
import { logout } from '@auth/store/auth.actions';
import { hydrateSuccess } from '@store/storage.actions';
import { State } from '@store/state.interface';

export const CLIENT_FEATURE_KEY = 'client';

export interface ClientState extends State<ClientDto> {}

export const initialState: ClientState = {
  data: null,
  detail: null,
  total: 0,
  query: null,
  loading: false,
  error: null,
};

export const clientReducer = createReducer(
  initialState,
  on(readClients, (state, { query }) => ({
    ...state,
    query: query ?? state.query,
    loading: true,
    error: null,
  })),
  on(readClientsSuccess, (state, { data, total }) => ({ ...state, data, total, loading: false })),
  on(readClientsFailure, (state, { error }) => ({ ...state, loading: false, error })),
  // Detail (single entity): the resolver blocks activation and matches by id, so we
  // keep the previous detail during the load (no blank flash on the outgoing page).
  on(readClient, (state) => ({ ...state, loading: true, error: null })),
  on(readClientSuccess, (state, { client }) => ({ ...state, detail: client, loading: false })),
  on(readClientFailure, (state, { error }) => ({ ...state, loading: false, error })),
  // Keep the open detail in sync with mutations so the form/restore-banner stay
  // correct without a refetch (the list itself is refetched by reloadAfterMutation$).
  on(updateClientSuccess, (state, { client }) => ({
    ...state,
    detail: state.detail ? { ...state.detail, ...client } : state.detail,
  })),
  on(deleteClientSuccess, (state, { client }) => ({ ...state, detail: client })),
  on(restoreClientSuccess, (state, { client }) => ({ ...state, detail: client })),
  // Create/update/delete/restore change the page contents or totals, so the
  // current page is refetched (see ClientEffects.reloadAfterMutation$) rather than
  // mutated in place — which would desync the paginator.
  on(hydrateSuccess, (state, { state: persisted }) =>
    persisted.client ? { ...state, ...persisted.client, detail: null } : state
  ),
  on(logout, () => initialState),
);
